import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { Button, Cell, Spacer, Text } from '@vinted/web-ui';
import { isEmpty } from 'lodash';
import FeaturedCollectionOnboardingModal from 'components/FeaturedCollection/FeaturedCollectionOnboardingModal';
import useBreakpoint from 'hooks/useBreakpoint';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { EDIT_FEATURED_COLLECTION_URL } from 'constants/routes';
import { Screen } from 'constants/tracking/screens';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import { navigateToPage } from 'libs/utils/window';
import FeaturedCollectionBox from './FeaturedCollectionBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const ProfileCollections = _ref => {
  let {
    collections,
    viewingSelf,
    allowBump
  } = _ref;
  const breakpoints = useBreakpoint();
  const {
    track
  } = useTracking();
  const translate = useTranslate();
  const {
    0: isOnboardingOpen,
    1: setIsOnboardingOpen
  } = useState(false);
  const collection = collections[0];

  function handleActivateClick() {
    setIsOnboardingOpen(true);
    track(clickEvent({
      screen: Screen.CurrentUserProfile,
      target: ClickableElement.ActivateFeaturedCollection
    }));
  }

  function handleOnboardingNextAction() {
    if (!collection) return;
    track(clickEvent({
      screen: Screen.FeaturedCollection,
      target: ClickableElement.ReviewCollection
    }));
    navigateToPage(EDIT_FEATURED_COLLECTION_URL(collection.id));
  }

  function handleOnboardingBackAction() {
    setIsOnboardingOpen(false);
  }

  function renderActivateCollection() {
    return /*#__PURE__*/_jsxs(Cell, {
      children: [/*#__PURE__*/_jsx(Button, {
        styling: Button.Styling.Filled,
        text: translate('featured_collection.actions.activate'),
        size: breakpoints.phones ? Button.Size.Medium : undefined,
        inline: !breakpoints.phones,
        onClick: handleActivateClick
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Medium,
        orientation: breakpoints.phones ? Spacer.Orientation.Horizontal : Spacer.Orientation.Vertical
      }), /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Caption,
        text: translate('featured_collection.activation_note')
      }), /*#__PURE__*/_jsx(FeaturedCollectionOnboardingModal, {
        show: isOnboardingOpen,
        isFeaturedCollectionCreated: true,
        onNextAction: handleOnboardingNextAction,
        onBack: handleOnboardingBackAction
      })]
    });
  }

  if (!collection || !viewingSelf && isEmpty(collection.items)) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.Large
    }), /*#__PURE__*/_jsx(FeaturedCollectionBox, _objectSpread(_objectSpread({}, collection), {}, {
      viewingSelf: viewingSelf,
      allowBump: allowBump,
      hasItems: !!collection.items.length
    })), !collection.isActive && renderActivateCollection()]
  });
};

export default ProfileCollections;